import React, {Component} from 'react';
import {Col, Form, Row} from "react-bootstrap";
import NumberFormat from "react-number-format";

class NumericSlider extends Component {
    state={
        value:this.props.elementProps.defaultValue,
        hasFocus:false
    }
    answerBouncer = null
    setAnswer = ()=>{
        clearTimeout(this.answerBouncer)
        this.answerBouncer = setTimeout(()=>{
            this.props.setAnswer(this.state.value)
        },100)
    }
    handleBlur=(e)=>{
        let val = e.target.value.replace(/\D/g, '')
        val = val === '' ? 0 : parseInt(val)
        this.setState({value:val,hasFocus:false},()=>{
            this.setAnswer()
        })
    }
    handleFocus = (e) =>{
        this.setState({hasFocus:true})
    }
    getValidClass = ()=>{
        if (this.state.hasFocus) return ''
        return this.props.elementProps.isValid ? 'is-valid': this.props.elementProps.isInvalid ? 'is-invalid':''

    }
    numbericInput = ()=>{
        const props = {
            displayType:"tel",
            thousandSeparator:true,
            prefix:this.props?.prefix,
            suffix:this.props?.suffix,
            decimalScale:0,
            allowNegative:false,
            className:`form-control ${this.getValidClass()}`,
            onBlur:this.handleBlur,
            value:this.state.value,
            onFocus:this.handleFocus
        }
        return <NumberFormat {...props} />
    }
    handleRangeChange=(e)=>{
        this.setState({value:e.target.value},()=>{
            this.setAnswer()
        })
    }
    render() {
        return (
            <div className="card input-group-card">
                <Row className="d-flex align-items-center gx-1 pb-2">
                    <Col>
                        <label className=""> {this.props.label} </label>
                    </Col>
                    <Col className="input-col">
                        {this.numbericInput()}
                        <Form.Control.Feedback type="invalid">
                            {this.props.elementProps?.isInvalid && this.props.error}
                        </Form.Control.Feedback>
                    </Col>
                </Row>
                <Form.Range step={this.props.step} size={'lg'} min={this.props.min} max={this.props.max} value={this.state.value} onChange={this.handleRangeChange}/>
            </div>
        );
    }
}

export default NumericSlider;